import { Component } from '@angular/core';

import {
  SkyWaitService
} from '../../core';


export class SkyWaitDemoComponent {
  public isWaiting = false;

  constructor(private waitSvc: SkyWaitService) { }

  public showPageWait(isBlocking: boolean) {
    if (isBlocking) {
      this.waitSvc.beginBlockingPageWait();
      setTimeout(() => {
        this.waitSvc.endBlockingPageWait();
      }, 2000);
    } else {
      this.waitSvc.beginNonBlockingPageWait();
      setTimeout(() => {
        this.waitSvc.endNonBlockingPageWait();
      }, 2000);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-wait-demo',
  template: `<button type="button" class="sky-btn sky-btn-default" (click)="isWaiting = !isWaiting">Toggle element wait</button>


<div style="height: 200px; width: 200px; margin-top: 10px;">
  A large area that can be waited with the <code>sky-wait</code> directive.
  <sky-wait [isWaiting]="isWaiting">
  </sky-wait>
</div>

<button type="button" class="sky-btn sky-btn-default" (click)="showPageWait(true)">Show page wait</button>

<button type="button" class="sky-btn sky-btn-default" (click)="showPageWait(false)">Show non-blocking page wait</button>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyWaitService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
